/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.9.1
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
import Vue from 'vue';
import Style from 'ol/style/style';
import { mergeDescriptors, style, withFillStrokeStyle } from '../core';

/**
 * Style box component.
 * Wrapper for ol.style.Style class. Can be inserted into component with setStyle/getStyle methods (vl-layer-vector, vl-feature & etc.)
 * and acts as a box for inner style components (vl-style-fill, vl-style-stroke, icon ...)
 */
var props = {
  zIndex: {
    type: Number,
    default: 0
  },
  condition: {
    type: [Function, Boolean],
    default: true
  }
};

var methods = {
  /**
   * @return {ol.style.Style}
   * @protected
   */
  createStyle: function createStyle() {
    return new Style({
      zIndex: this.zIndex,
      image: this._image,
      stroke: this._stroke,
      fill: this._fill,
      text: this._text,
      geometry: this._geometry
    });
  },

  /**
   * @returns {Object}
   * @protected
   */
  getServices: function getServices() {
    var vm = this;

    return mergeDescriptors(style.methods.getServices.call(this), {
      get stylesContainer() {
        return vm;
      }
    });
  },

  /**
   * @return {void}
   * @protected
   */
  mount: function mount() {
    this.$stylesContainer && this.$stylesContainer.addStyle(this);
  },

  /**
   * @return {void}
   * @protected
   */
  unmount: function unmount() {
    this.$stylesContainer && this.$stylesContainer.removeStyle(this);
  },

  /**
   * @param {ol.style.Image|Vue|undefined} image
   * @return {void}
   */
  setImage: function setImage(image) {
    image = image instanceof Vue ? image.$style : image;

    if (image !== this._image) {
      this._image = image;
    }
    if (this.$style && image !== this.$style.getImage()) {
      this.$style.setImage(image);
      this.refresh();
    }
  },

  /**
   * @param {ol.geom.Geometry|Vue|undefined} geom
   * @return {void}
   */
  setGeometry: function setGeometry(geom) {
    geom = geom instanceof Vue ? geom.$geometry : geom;

    if (geom !== this._geometry) {
      this._geometry = geom;
    }
    if (this.$style && geom !== this.$style.getGeometry()) {
      this.$style.setGeometry(geom);
      this.refresh();
    }
  },

  /**
   * @param {ol.style.Text|undefined} text
   * @return {void}
   */
  setText: function setText(text) {
    text = text instanceof Vue ? text.$style : text;

    if (text !== this._text) {
      this._text = text;
    }
    if (this.$style && text !== this.$style.getText()) {
      this.$style.setText(text);
      this.refresh();
    }
  }
};

var watch = {
  zIndex: function zIndex(value) {
    if (!this.$style) return;

    this.$style.setZIndex(value);
    this.refresh();
  }
};

var Style$1 = {
  name: 'vl-style-box',
  mixins: [style, withFillStrokeStyle],
  props: props,
  methods: methods,
  watch: watch,
  created: function created() {
    /**
     * @type {ol.style.Image|undefined}
     * @private
     */
    this._image = undefined;
    /**
     * @type {ol.style.Text|undefined}
     * @private
     */
    this._text = undefined;
    /**
     * @type {ol.geom.Geometry|undefined}
     * @private
     */
    this._geometry = undefined;
  },
  destroyed: function destroyed() {
    this._image = this._text = this._geometry = undefined;
  }
};

var index = {
  Style: Style$1,
  install: function install(Vue$$1) {
    Vue$$1.component(Style$1.name, Style$1);
  }
};

export default index;

//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/vuelayers/lib/style-box/index.es.js
// module id = null
// module chunks = 